// extracted by mini-css-extract-plugin
export default {"inputs":"TextInputTable_inputs__CormS"};